import clsx from 'clsx';
import { CalendarDaysIcon, ExclamationTriangleIcon, ClockIcon } from '@heroicons/react/24/outline';
import {
    NEARBY_BADGE_CLASS,
    NEARBY_BADGE_PREFIX,
    OVERLAP_BADGE_CLASS,
    OVERLAP_BADGE_PREFIX,
    SCHEDULED_BADGE_PREFIX,
    SCHEDULED_BADGE_CLASS,
    formatBadgeNames,
    formatNameList,
    type GroupedConflictNames,
} from '../vacationClientPanel.definitions';

export interface ConflictBadgesProps {
    conflicts: GroupedConflictNames;
}

const BADGE_BASE = 'inline-flex w-fit max-w-full items-start gap-1.5 rounded-md px-2 py-1 text-xs font-montserrat';

export function ConflictBadges({ conflicts }: ConflictBadgesProps) {
    return (
        <div className="flex flex-col gap-1.5">
            {conflicts.overlapping.length > 0 && (
                <span
                    title={formatNameList(conflicts.overlapping)}
                    className={clsx(BADGE_BASE, 'font-semibold', OVERLAP_BADGE_CLASS)}
                >
                    <ExclamationTriangleIcon className="mt-px h-3.5 w-3.5 shrink-0" aria-hidden="true" />
                    {`${OVERLAP_BADGE_PREFIX} ${formatBadgeNames(conflicts.overlapping)}`}
                </span>
            )}
            {conflicts.nearby.length > 0 && (
                <span
                    title={formatNameList(conflicts.nearby)}
                    className={clsx(BADGE_BASE, 'font-medium', NEARBY_BADGE_CLASS)}
                >
                    <ClockIcon className="mt-px h-3.5 w-3.5 shrink-0" aria-hidden="true" />
                    {`${NEARBY_BADGE_PREFIX} ${formatBadgeNames(conflicts.nearby)}`}
                </span>
            )}
            {conflicts.scheduled.length > 0 && (
                <span
                    title={formatNameList(conflicts.scheduled)}
                    className={clsx(BADGE_BASE, 'font-medium', SCHEDULED_BADGE_CLASS)}
                >
                    <CalendarDaysIcon className="mt-px h-3.5 w-3.5 shrink-0" aria-hidden="true" />
                    {`${SCHEDULED_BADGE_PREFIX} ${formatBadgeNames(conflicts.scheduled)}`}
                </span>
            )}
        </div>
    );
}

export default ConflictBadges;
